import React, { useState, useEffect } from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import {loadStripe} from '@stripe/stripe-js';
import { TextField } from 'formik-material-ui';
import MuiTextField from '@material-ui/core/TextField';
import { makeStyles, Container, Grid, LinearProgress, Typography, Checkbox, FormControl, FormControlLabel,
     Button, List,ListItem,ListItemText, FormHelperText , Select, MenuItem,
      IconButton, Divider, Stepper , Step, StepLabel, Paper, InputBase , CircularProgress} from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import {Alert} from '@material-ui/lab';
import SearchIcon from '@material-ui/icons/Search';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { Autocomplete } from 'formik-material-ui-lab';
import {FormikPersistStore} from '../../component/FormikPersistStore'
import { useParams, useRouteMatch } from 'react-router-dom';
import { asyncCheck, asyncPurchase } from '../../redux/ducks/domain';
import { readMerchant } from '../../redux/ducks/merchant';
import { MyMess, history } from '../../App';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import Axios from 'axios';
import parsePhoneNumber from 'libphonenumber-js';
import {Countries as countries} from '../../utils/CountryList';
import {PAYMENT_METHOD, isCreditCardOnly, isPaymentMethodEnable} from '../../utils/Config';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { loadStripeService, QueryPayment } from '../../server/WebServiceUrl';
import {GreenButton} from '../../component/colorButton';
import {isAlphanumeric, isAlphabet, isAlphanumericWithSymbols, parseCountry, parsePhone} from '../../utils/Utils';
import QrCode from "../components/QrCode";
import PaymentIcon from '@material-ui/icons/Payment';
const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
const domainPrefixRegex  =/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]+$/;
var alipayLogo = require("../../images/payments/alipay.png");
var wechatpayLogo = require("../../images/payments/wechatpay.png");

const fields = {
    firstName: {
        required: true,
        isAlphabet: true,
        isAlphanumeric: false,
        isAlphanumericWithSymbols: false,
        maxLength: 100
    },
    lastName:{
        required: true,
        isAlphabet: true,
        maxLength: 100
    },
    phone:{
        required: true,
        maxLength: 20
    },
    ownerEmail:{
        required: true,
        maxLength: 100
    },
    address1:{
        required: true,
        isAlphanumericWithSymbols: true,
        maxLength: 100
    },
    address2:{
        required: true,
        isAlphanumericWithSymbols: true,
        maxLength: 100
    },
    city:{
        required: true,
        isAlphabet: true,
        maxLength: 255
    },
    state:{
        required: true,
        isAlphabet: true,
        maxLength: 255
    },
    postalCode:{
        required: true,
        isAlphanumeric: true,
        maxLength: 15
    },
    companyName: {
        required: false,
        isAlphanumericWithSymbols: true,
        maxLength: 255
    }
}

const useStyles = makeStyles((theme) => ({
    paperContainer: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        // width: 800,
      },
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    paymentPaperWrapper:{
        marginTop: theme.spacing(8),
    },
    paymentPaper: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    spinner: {
        margin: 10
    },
    option: {
        fontSize: 15,
        '& > span': {
          marginRight: 10,
          fontSize: 18,
        },
    },
    divider: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5)
    },
    domainItem: {
        display: 'flex',
        padding: 10,
        // marginBottom: 7,
        alignItems: 'center',

    },
    domainText: {
        fontSize: 18,
        display: 'flex',
        alignItems: 'center',
    },
    flexOne: {
        flex: 1,
    },
    flexTwo: {
        flex: 2 
    },
    errorPhoneGrid: {
        '& .react-tel-input': {
            width: '100%',
            '& .special-label': {
                background: '#fafafa',
                color: theme.palette.error.main
            },
            '& input': {
                background: 'transparent',
                width: '100%',
            },
            '& .form-control': {
                borderColor: theme.palette.error.main,
            },
            '& .form-control:focus': {
                boxShadow: '0 0 0 1px ' + theme.palette.error.main
            }
        }
    },
    phoneGrid: {
        '& .react-tel-input': {
            width: '100%',
            '& .special-label': {
                background: '#fafafa'
            },
            '& input': {
                background: 'transparent',
                width: '100%',
            },
            '& .form-control:focus': {
                borderColor: theme.palette.primary.main,
                boxShadow: '0 0 0 1px ' + theme.palette.primary.main
            }
        }
    },
    generalPaperPadding: {
        padding: theme.spacing(2),
    },
    greyAlert:{
        padding: 0,
        color: '#666',
        backgroundColor: 'transparent',
        '& .MuiAlert-icon': {
            color: '#666',
        }
    },
    paperLabel: {
        fontSize: 16,
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
    },
    currentPrice: {
        color: theme.palette.primary.main,
        fontSize: 18,
    }
  }));
  
  function getSteps() {
    return [MyMess.domains.buyNew.selectDomain, MyMess.domains.buyNew.provideInfo, MyMess.domains.buyNew.payment];
  }

  function getContactData (mer) {
    return {
        address1: isAlphanumericWithSymbols(mer.addr, true)? mer.addr : '',
        address2: isAlphanumericWithSymbols(mer.addr2, true)? mer.addr2 : '',
        city: isAlphabet(mer.city, true)? mer.city : '',
        state: isAlphabet(mer.province, true)? mer.province : '',
        companyName: isAlphanumericWithSymbols(mer.compName, true)? mer.compName : '',
        country: parseCountry(mer.countryISO, mer.country),
        firstName: isAlphabet(mer.firstName, true)? mer.firstName : '',
        lastName: isAlphabet(mer.lastName, true)? mer.lastName : '',
        ownerEmail: mer.email,
        phone: parsePhone(mer.countryCode, mer.areaCode, mer.tel),
        postalCode: isAlphanumeric(mer.zipCodeStr, true)? mer.zipCodeStr : ''
    };
}

function DomainsEditForm(props) {
    // let merchant = props.merchant;
    let interval = null;
    const merchant = useSelector(state => state.merchant);
    
    const classes = useStyles();
    const [isInitiating, setInitiating] = React.useState(true);
    useEffect(() => {
        dispatch(readMerchant(user.email, function(resp){

            if(resp.data && resp.data.merchant) {
                setContactData(getContactData(resp.data.merchant));
            }
            setInitiating(false);
        }));
      }, []);

    useEffect(() => {
        interval = setInterval(getOrderStatus, 2000);
    
        return function cleanup() {
            if (interval) {
                clearInterval(interval);
            }
        };
    });

    const user = useSelector(state => state.user);
    
    const [contactData, setContactData]= React.useState( () => getContactData(merchant) );
    
    const [searchValue, setSearchValue] = React.useState('');
    const [selectedDomain, setSelectedDomain] = React.useState({});
    const [availableList, setAvailableList] = React.useState([]);
    const [privacyPrice, setPrivacyPrice] = React.useState(4);
    const [agreementState, setAgreementState] = React.useState({
        list: [],
        isAgreed: false
    });
    
    const [mainState, setMainState] = useState({
        mode:'edit',
        pending: false,
        showAC: false,        
    });
    const [years, setYears]  = React.useState(1);
    const [ whoIsPrivacy, setWhoIsPrivacy] = React.useState(false);
    const [contactControlState, setContactControlState ] = React.useState({
        isPostalCodeEditable: true,
        isStateEditable: true,
    });
    const [paymentMethod, setPaymentMethod] = React.useState('');
    const [openQrCode, setOpenQrCode] = React.useState(false);
    const [qrCodeString, setQrCodeString] = React.useState("");
    const [referenceNo, setReferenceNo] = React.useState("");

    const dispatch = useDispatch();

    const handleClose = () => {
        // send cancel payment request might be required
        setOpenQrCode(false);
        setQrCodeString('');
        setReferenceNo('');
    };

    const handleYearChange = (event) => {
        setYears(event.target.value);
      };

    const handleChange = (event) => {
        setSearchValue(event.target.value.replace(/ /g, '').toLowerCase());
    };

    const handleWhoIsPrivacyChange = (event) => {
        setWhoIsPrivacy(event.target.checked);
    }

    const getPricing = () => {
        if (!whoIsPrivacy) {
            return selectedDomain.pricing.addnewdomain;
        } else {
            return selectedDomain.pricing.addnewdomain + privacyPrice
        }
    }

    const getPricingDesc = () => {
        if (!whoIsPrivacy) {
            return selectedDomain.pricing.addnewdomain;
        } else {
            return `${selectedDomain.pricing.addnewdomain + privacyPrice} (${selectedDomain.pricing.addnewdomain} + ${privacyPrice})`
        }
    }

    const allowPurchaseWHOIS = () => {
        const tld = selectedDomain.domain.split('.')[1];
        const tlds = ["org", "net", "com", "co", "xyz"];
        if (tlds.indexOf(tld) != -1 ){
            return true;
        }
        return false;
    }
 
    const updateStoreHandler = (data) => {

        // c
        setContactData(data)
    }




    const validateHandler = (values) => {
       
        const errors = {};
        ['firstName','lastName', 'phone', 'ownerEmail',
         'address1', 'address2', 'city', 'state', 'postalCode', 'companyName'].forEach(key => {

            let field = fields[key];
            let value = values[key];

            if( field &&  field.required && ( !value || value.trim().length === 0 ) ) {
                errors[key] = MyMess.general.errors.required
            } else if (field.maxLength && value && value.length > field.maxLength) {
                errors[key] = MyMess.formatString(MyMess.general.errors.maxLength, fields[key].maxLength )
            } else if (field.isAlphabet && value &&  !isAlphabet(value, true)) {
                errors[key] = MyMess.general.errors.englishOnly
            } else if (field.isAlphanumeric && value &&  !isAlphanumeric(value, true)) {
                errors[key] = MyMess.general.errors.alphanumericOnly
            } else if (field.isAlphanumericWithSymbols && value &&  !isAlphanumericWithSymbols(value, true)) {
                errors[key] = MyMess.general.errors.alphanumericSymbolOnly
            }
            
         });
         
         if (!values.country) {
            errors.country = MyMess.general.errors.required
         } else if (values.country.code && values.country.code.length !=2) {
            errors.country = MyMess.general.errors.required
         }

        if (values.phone && values.phone.length > 0 ) {
            const phoneNumber = parsePhoneNumber('+'+values.phone);
            if (!phoneNumber || !phoneNumber.isPossible()) {
                errors.phone = MyMess.general.errors.phone
            }
        }

        // fast email format validation
        if (values.ownerEmail && !emailRegex.test(values.ownerEmail)) {
            errors.ownerEmail = MyMess.general.errors.email
        }

        return errors;
    }
    
    const getPhoneHelperText = (errorMessage) => {

        if (errorMessage) {
            return errorMessage;
        }

        if (contactData.phone && contactData.phone.length > 0 ) {

            let phone = contactData.phone;
            if (!phone.startsWith('+')) {
                phone = '+' + contactData.phone;
            }

            const phoneNumber = parsePhoneNumber(phone);
            if (phoneNumber && phoneNumber.isPossible()) {
                return `(${phoneNumber.country? phoneNumber.country: 'unknown'}) ${phoneNumber.format("INTERNATIONAL")}`;
            }
        }

        return `${MyMess.general.exampleShort} +852 29616333`;
    }

    const formatPhoneNumber = (phoneNumberText) => {
        let phone = phoneNumberText;
        if (!phone.startsWith('+')) {
            phone = '+' + phoneNumberText;
        }

        const phoneNumber = parsePhoneNumber(phone);
        if (phoneNumber && phoneNumber.isPossible()) {
            return `(${phoneNumber.country? phoneNumber.country: 'unknown'}) ${phoneNumber.format("INTERNATIONAL")}`;
        }
        return '';
    }

    const startLoadingBar = () => {
        setMainState({
            ...mainState,
            pending: true
        })
    }

    const stopLoadingBar = () => {
        setMainState({
            ...mainState,
            pending: false
        })
    }

    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const getOrderStatus = async () => {
        if (referenceNo) {
            let result = {};
            try{
                result = await Axios.post(QueryPayment,{referenceNo});     
            }catch(e){
                if (e.response && e.response.data && e.response.data.error) {
                    console.error(e.response.data);
                }
            }
            if (result && result.data && result.data.isPaid) {
                history.push('/main/domains');
            }
        
        }
     }

    const handleConfirm = async (event)  => {
        event.preventDefault();
        startLoadingBar();

        let phone = contactData.phone;
        if (!phone.startsWith('+')) {
            phone = '+' + contactData.phone;
        }

        const phoneNumber = parsePhoneNumber(phone);
       
        // validation?
        const domainName = selectedDomain.domain;
        const contact = {
            firstName: contactData.firstName,
            lastName: contactData.lastName,
            email: contactData.ownerEmail.toLowerCase(),
            countryCallingCode: phoneNumber.countryCallingCode,
            phoneNumber: phoneNumber.nationalNumber,
            addr: contactData.address1,
            addr2: contactData.address2,
            city: contactData.city,
            province: contactData.state,
            country: contactData.country.label,
            zipCode: contactData.postalCode,
            countryCode: contactData.country.code,
            companyName: contactData.companyName,

        };
        dispatch(asyncPurchase(contact, domainName, years, whoIsPrivacy, paymentMethod, payCallback));
        // create charge and redirect?

        // server check Country and set state, province and postal code to N/A
        
    }

    const  payCallback = async (resp) => {
        let stripe;
        let isShowDialog = false;
        if (resp && resp.status === 200 && resp.data) {

            if (paymentMethod == PAYMENT_METHOD.ALIPAY || paymentMethod == PAYMENT_METHOD.WECHAT_PAY) {
                // show dialog  
                isShowDialog = true;
                setReferenceNo(resp.data.referenceNo);
                setQrCodeString(resp.data.qr_code);
                setOpenQrCode(true);
            } else {
                stripe = await loadStripeService(resp.data);
            }
        }

        stopLoadingBar();
        if (!isShowDialog) {
            if (resp && resp.status === 200 && resp.data && stripe) {
                stripe
                .redirectToCheckout({
                   sessionId: resp.data.session_id
                })
                .then(function (result) {
                   console.error(result.error.message);
                });
    
            } else if(resp.error) {
                GlobalSnackBarUtil.open({
                    message:MyMess.curd.saveFail,
                    severity:'error'
                })
            } else {
                GlobalSnackBarUtil.open({
                    message:MyMess.curd.saveFail,
                    severity:'error'
                })
            }
        }
       
    }


    const handleReset = () => {
        setActiveStep(0);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        startLoadingBar();

        let trimValue = searchValue;

        // no need www.
        if (trimValue.startsWith("www.")) {
            trimValue = trimValue.slice(4);
        }

        const isContainsDot = trimValue.includes('.');
        let checkingRegex = domainPrefixRegex;
        let errorMsg = "";
        if (isContainsDot) {
            checkingRegex = domainRegex;
        }

        if (checkingRegex.test(trimValue) === false) {
            errorMsg = MyMess.domains.errors.invalidCharacters;
        } else if (trimValue.length <= 3) {
            errorMsg = MyMess.formatString(MyMess.general.errors.minLength, 4);
        } else if (trimValue.length > 63) {
            errorMsg = MyMess.formatString(MyMess.general.errors.maxLength, 63);
        }

        if (errorMsg) {
            stopLoadingBar();
            GlobalSnackBarUtil.open({
                message: errorMsg,
                severity:'error'
            })
            return;
        }

        dispatch(asyncCheck(trimValue, searchCallback));

    };

    const handleAgreementChange = (event) => {
        setAgreementState({...agreementState, isAgreed: event.target.checked})
    }

    const handlePaymentMethodChange = (event) => {
        setPaymentMethod(event.target.value)
    }

    const searchCallback = (resp) => {
        stopLoadingBar();
        if (resp && resp.status === 200 && resp.data) {
            setAvailableList(resp.data.available)
            setPrivacyPrice(resp.data.privacyProtection)
        } else if(resp.error) {
            GlobalSnackBarUtil.open({
                message:MyMess.domains.errors[resp.error],
                severity:'error'
            })
        } else {
            GlobalSnackBarUtil.open({
                message:MyMess.curd.getFail,
                severity:'error'
            })
        }
    }

    const selectDomain = (domainItem) => {
        setSelectedDomain(domainItem);
        const tld = domainItem.domain.split('.')[1];
        handleNext();
        setAgreementState({
            ...agreementState,
            list: [
                {url: 'https://www.resellerclub.com/legal-agreements#dra'}
            ]
        })
    }

    const checkContact = (values, actions) => {
        handleNext();
        actions.setSubmitting(false);
    }

    const renderSelectDomainStep = () => {

        if (activeStep === 0) {
            let btn = (
                <IconButton type="submit" className={classes.iconButton} aria-label="search"  >
                    <SearchIcon />
                </IconButton>
            );
            if (mainState.pending) {
                btn = <CircularProgress className={classes.spinner} size={24} thickness={3} />
            }
            return (
                <Grid container justify='center'>
                    <Grid item xs={12} sm={9}>
                        <Paper component="form" onSubmit={handleSearch} className={classes.paperContainer}>
                            <InputBase
                                className={classes.input}
                                placeholder={`${MyMess.general.exampleShort} example.com`}
                                inputProps={{ 'aria-label': 'search domains', maxLength: 63 }}
                                value={searchValue}
                                onChange={handleChange}
                            />
                            {btn}
                        </Paper>
                        <Typography variant="subtitle1">{MyMess.domains.buyNew.enterDomain}</Typography>
                    </Grid>
                    {renderAvailableList()}
                </Grid>
            )
        } else if (activeStep === 1) {

            if (mainState.pending && agreementState.list.length === 0) {
                return (
                    <Grid container justify='center'>
                        <CircularProgress className={classes.spinner} size={60} thickness={4} />
                    </Grid>
                )
            } else if (isInitiating) {
                return (
                    <Grid container justify='center'>
                        <CircularProgress className={classes.spinner} size={60} thickness={4} />
                    </Grid>
                )
            }
            return (
                <Grid  container justify='center'>
                    
                    <Grid  item xs={12} sm={9}>
                    <Alert severity="info" className={classes.greyAlert}>{MyMess.domains.contact.englishOnly}</Alert>
                        <Paper elevation={3}>
                            <div className={classes.paperLabel} >{MyMess.domains.domainContactLabel}</div>
                            <Paper elevation={0} className={classes.generalPaperPadding} >
                                <Formik
                                    initialValues={contactData}        
                                    validate={validateHandler}  
                                    // enableReinitialize={true}
                                    onSubmit={checkContact}
                                    >

                                {({
                                    setFieldValue,
                                    isSubmitting,
                                    errors
                                })=>(
                                    <Form className={classes.form}  >
                                        <Grid container spacing={2} >
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    component={TextField}
                                                    required
                                                    label={MyMess.general.firstName}
                                                    name="firstName"
                                                    fullWidth                                
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    component={TextField}
                                                    required
                                                    name="lastName"
                                                    label={MyMess.general.lastName}   
                                                    fullWidth                                  
                                                /> 
                                            </Grid>
                                            <Grid item xs={12} className={errors.phone? classes.errorPhoneGrid :classes.phoneGrid}>
                                                <Field
                                                    required
                                                    name="phone"
                                                    render={(props) => 
                                                        <PhoneInput
                                                            country="hk"
                                                            placeholder=""
                                                            preferredCountries={['hk', 'mo', 'tw' ,'my', 'sg', 'cn']}
                                                            value={contactData.phone}
                                                            onChange={phone => setFieldValue("phone", phone)}
                                                            specialLabel={`${MyMess.general.phoneNumber} *`}
                                                            inputProps={{
                                                                id:"contact-phone",
                                                                name: 'phone',
                                                                required: true,
                                                                'aria-describedby':"phone-helper-text"
                                                            }}
                                                        />
                                                    }
                                                />
                                                <FormHelperText error={errors.phone} id="phone-helper-text">{getPhoneHelperText(errors.phone)}</FormHelperText>
                                            </Grid>
                                            <Grid item xs={12}>    
                                                <Field
                                                    component={TextField}
                                                    name="ownerEmail"
                                                    type="email"
                                                    inputProps={{ style: { textTransform: "lowercase" } }}                                 
                                                    required
                                                    label={MyMess.domains.ownerEmail}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12}>      
                                                <Field
                                                    component={TextField}
                                                    name="companyName"   
                                                    label={MyMess.domains.companyName}
                                                    fullWidth                             
                                                    
                                                />
                                            </Grid>
                                            <Grid item xs={12}>      
                                                <Field
                                                    component={TextField}
                                                    name="address1"
                                                    required
                                                    label={MyMess.general.addr1}
                                                    fullWidth                                
                                                />      
                                            </Grid>
                                            <Grid item xs={12}>     
                                                <Field
                                                    component={TextField}
                                                    name="address2"
                                                    required
                                                    label={MyMess.general.addr2}
                                                    fullWidth                                
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>   
                                                <Field
                                                    component={TextField}
                                                    name="city"        
                                                    required
                                                    label={MyMess.general.city}
                                                    fullWidth                        
                                                /> 
                                            </Grid> 
                                            <Grid item xs={12} md={6}>   
                                                <Field
                                                    component={TextField}
                                                    name="state"        
                                                    required
                                                    label={MyMess.general.state}
                                                    fullWidth                        
                                                /> 
                                            </Grid> 
                                            <Grid item xs={12} md={6}>   
                                                <Field
                                                    component={TextField}
                                                    name="postalCode"
                                                    required
                                                    label={MyMess.general.postalCode}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>       
                                                <Field
                                                    component={Autocomplete}
                                                    name="country"
                                                    required
                                                    label={MyMess.general.country}
                                                    fullWidth
                                                    classes={{
                                                        option: classes.option,
                                                    }}
                                                    onChange={(e, value) => {
                                                        setFieldValue("country", value)
                                                        if(value && value.code === 'HK') {
                                                            setFieldValue("postalCode", '000000')
                                                            setFieldValue("state", 'Hong Kong')
                                                            setContactControlState({
                                                                isPostalCodeEditable: false,
                                                                isStateEditable: false,
                                                            })
                                                        } else {
                                                            setContactControlState({
                                                                isPostalCodeEditable: true,
                                                                isStateEditable: true,
                                                            })
                                                        }
                                                    }}
                                                    options={countries}
                                                    
                                                    getOptionLabel={(option) => option? (  `${option.label} (${option.code})` || ''):''}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                        
                                                            label={MyMess.general.country}
                                                            variant="outlined"
                                                            helperText={errors['country']}
                                                            inputProps={{
                                                                required: true,
                                                                ...params.inputProps,
                                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>       
                                                <Field
                                                    name="support"
                                                    render={(props) => 
                                                        <FormControlLabel
                                                            control={<Checkbox {...props} checked={agreementState.isAgreed} disabled={isSubmitting} onChange={handleAgreementChange} name="support" />}
                                                            label={ MyMess.formatString(MyMess.domains.acceptAgreement, <a target="_blank" href={agreementState.list[0].url}>{MyMess.domains.acceptAgreementLinkText}</a>)}
                                                        />}
                                                />
                                            </Grid>

                                            <Grid item xs={12} >
                                                <Button onClick={handleBack} className={classes.button} disabled={isSubmitting}>
                                                    {MyMess.general.back}
                                                </Button>
                                                <Button
                                                    disabled={isSubmitting || !agreementState.isAgreed}
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                >
                                                    {MyMess.general.next}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        
                                        <FormikPersistStore name="licenseEditForm" handler={updateStoreHandler}></FormikPersistStore>
                                    </Form>
                                    
                                )}
                                </Formik>
                            </Paper>
                        </Paper>
                    </Grid>
                   
                </Grid>
            )
        } else if (activeStep === 2) {
            return renderPayment();
        }
        return null;
    }

    const renderDomainPricing = (pricing) => {

        if (pricing.addnewdomain != pricing.renewdomain) {
            return (
                <div  className={classes.flexTwo}>
                <div className={classes.currentPrice} >{`${pricing.currency} ` + pricing.addnewdomain + MyMess.domains.perYear }</div>
                <div>{`(${MyMess.domains.nextYearRenew}: ${pricing.currency} ${pricing.renewdomain}${MyMess.domains.perYear}) `}</div>
            </div>
            )
        }

        return (
            <div className={classes.flexTwo}>
                <div>{MyMess.formatString(MyMess.domains.perYearCharge, pricing.currency, pricing.addnewdomain) }</div>
            </div>
        )
    }

    const renderAvailableList = () => {
        if (availableList.length === 0) {
            return null;
        }
        const listItems = [];


        if(availableList[0].status === 'available') {
            if (availableList[0].isMatch){
                listItems.push(
                    <div className={classes.paperLabel} >{MyMess.domains.available}</div>
                )
            }else {
                listItems.push(
                    <div className={classes.paperLabel} >{MyMess.domains.title}</div>
                )
            }
        } else {
            listItems.push(
                <div className={classes.paperLabel} style={{backgroundColor:'#444'}} >{MyMess.domains.notAvailable}</div>
            )
        }

        

        availableList.forEach((item, i) => {

            let icon = null;
            let fontSize = 18;

            if (item.isMatch) {
                fontSize = 24;

                if(item.status === 'available') {
                    icon = <CheckCircleIcon style={{ color: '#54b9a4', marginLeft: 8 }} />;
                } else {
                    icon = <CancelIcon style={{ color: '#444', marginLeft: 8 }} />;
                }

            } 

            if (i == 0 && !item.isMatch && availableList.length > 1) {
                listItems.push(
                    <div style={{padding:8, textAlign:'center', background: '#eee', color:'#666' }}>{MyMess.domains.suggestion}</div>
                )
            }

            if (item.status  != 'available') {

                let status = MyMess.domains.statuses.notAvailable;
                if (item.status  ==='regthroughus' || item.status  == 'regthroughothers') {
                    status = MyMess.domains.statuses.taken;
                } else if (item.isInvalidTLD) {
                    status = MyMess.domains.statuses.notSupported;
                }

                listItems.push(
                    <Paper key={item.domain} elevation={0} className={classes.domainItem}  >
                        <div className={`${classes.flexTwo} ${classes.domainText}`} style={{fontSize}} >{item.domain} {icon}</div>
                        < div className={classes.flexTwo} style={{fontSize}}>
                            {status}
                           
                        </div>
                        < div className={classes.flexOne} style={{fontSize}}>
                            {``}
                        </div>
                        <Divider />
                    </Paper>
                   
                )
            } else {
                listItems.push(
                    <Paper key={item.domain} elevation={0} className={classes.domainItem} >
                        <div className={`${classes.flexTwo} ${classes.domainText}`} style={{fontSize}} >{item.domain} {icon}</div>
                        {renderDomainPricing(item.pricing)}
                       
                        < div  className={classes.flexOne}>
                        <GreenButton variant="contained" color="primary" edge="end" onClick={selectDomain.bind(this, item)} className={classes.button}>
                            {MyMess.general.select}
                        </GreenButton>
                        </div>
                    </Paper>
                )
            }
            

            if (i == 0 && item.isMatch && availableList.length > 1) {
                listItems.push(
                    <div style={{padding:8, textAlign:'center', background: '#eee', color:'#666' }}>{MyMess.domains.otherSuggestion}</div>
                )
            }

            if (i+1 != availableList.length) {
                listItems.push(
                    <Divider key={`${item.domain}_divider`} />
                )
            }
            
        })

        return (
            <Grid item xs={12} sm={9}>
                <List component="div">
                    {listItems}
                </List>
            </Grid>
        )
    }

    const renderPayment = () => {
        return (
            <Grid container spacing={2} justify='center'>
                <Grid container>
                    <Paper elevation={3} className={classes.paymentPaperWrapper}>
                    <div className={classes.paperLabel} >{MyMess.domains.payment.title}</div>
                        {/* Order Info */}
                        <Paper elevation={0} className={classes.paymentPaper}>
                        {/* <Grid item xs={12} >
                            <div style={{display: 'flex', alignItems: 'center',  fontSize: 16}}>
                                <div style={{flex: 1}} >Domain</div>
                                <div style={{flex: 1}} >Year(s)</div>
                                <div style={{flex: 1}} >Pricing</div>
                                <div style={{flex: 1}} >Total</div>
                            </div>
                            <Divider className={classes.divider} />
                        </Grid> */}
                        <Grid item xs={12} >
                            {/* <Typography variant="subtitle1">{MyMess.domains.payment.title}</Typography> */}
                            <div style={{display: 'flex', alignItems: 'center', fontSize: 16}}>
                                <div style={{flex: 2}} >{selectedDomain.domain}</div>
                                <div style={{flex: 1}}>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            labelId="year-select-label"
                                            id="year-simple-select"
                                            value={years}
                                            onChange={handleYearChange}
                                        >
                                            <MenuItem value={1}>{MyMess.formatString(MyMess.domains.singleYear, 1)}</MenuItem>
                                            <MenuItem value={2}>{MyMess.formatString(MyMess.domains.multiYears, 2)}</MenuItem>
                                            <MenuItem value={3}>{MyMess.formatString(MyMess.domains.multiYears, 3)}</MenuItem>
                                            <MenuItem value={4}>{MyMess.formatString(MyMess.domains.multiYears, 4)}</MenuItem>
                                            <MenuItem value={5}>{MyMess.formatString(MyMess.domains.multiYears, 5)}</MenuItem>
                                            {/* <MenuItem value={6}>{MyMess.formatString(MyMess.domains.multiYears, 6)}</MenuItem> */}
                                            {/* <MenuItem value={7}>{MyMess.formatString(MyMess.domains.multiYears, 7)}</MenuItem> */}
                                            {/* <MenuItem value={8}>{MyMess.formatString(MyMess.domains.multiYears, 8)}</MenuItem> */}
                                            {/* <MenuItem value={9}>{MyMess.formatString(MyMess.domains.multiYears, 9)}</MenuItem> */}
                                            {/* <MenuItem value={10}>{MyMess.formatString(MyMess.domains.multiYears, 10)}</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </div>
                                {/* <div style={{flex: 2}}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={whoIsPrivacy}
                                                onChange={handleWhoIsPrivacyChange}
                                                name="whoIsPrivacy"
                                                color="primary"
                                            />
                                        }
                                        label={MyMess.domains.purchasePrivacy}
                                    />
                                </div> */}
                                <div style={{flex: 2}}>{MyMess.formatString(MyMess.domains.perYearCharge, selectedDomain.pricing.currency, getPricingDesc())}</div>
                                <div style={{flex: 2}}>{MyMess.general.total}: {selectedDomain.pricing.currency} {(getPricing() * years).toFixed(2)} </div>
                            </div>
                            {!isCreditCardOnly() && <div style={{display: 'flex', fontSize: 16}}>

                                <div style={{display: 'flex', alignSelf: 'center', marginRight: 30}}>{MyMess.payment.selectMethod}:</div>
                                <FormControlLabel
                                    control={<Checkbox checked={paymentMethod === PAYMENT_METHOD.CREDIT_CARD} 
                                    onChange={handlePaymentMethodChange} name="paymentMethod" value={PAYMENT_METHOD.CREDIT_CARD} />}
                                    label={<div style={{display: 'flex'}}><PaymentIcon style={{marginRight: 5}} /> {MyMess.payment.methods.creditCard}</div>}
                                />
                                {isPaymentMethodEnable(PAYMENT_METHOD.ALIPAY) &&  <FormControlLabel
                                    control={<Checkbox checked={paymentMethod === PAYMENT_METHOD.ALIPAY} 
                                    onChange={handlePaymentMethodChange} name="paymentMethod" value={PAYMENT_METHOD.ALIPAY} />}
                                    label={
                                        <div style={{display: 'flex'}}>
                                            <img style={{marginRight: 5, width: '1em', height: '1em', fontSize:'1.5rem'}} src={alipayLogo} /> 
                                            {MyMess.payment.methods.alipay} 
                                        </div>
                                    }
                                />}
                                {isPaymentMethodEnable(PAYMENT_METHOD.WECHAT_PAY) && <FormControlLabel
                                    control={<Checkbox checked={paymentMethod === PAYMENT_METHOD.WECHAT_PAY} 
                                    onChange={handlePaymentMethodChange} name="paymentMethod" value={PAYMENT_METHOD.WECHAT_PAY} />}
                                    label={
                                        <div style={{display: 'flex'}}>
                                            <img style={{marginRight: 5, width: '1em', height: '1em', fontSize:'1.5rem'}} src={wechatpayLogo} /> 
                                            {MyMess.payment.methods.wechatPay}
                                        </div>
                                    }
                                />}
                                
                            </div>}
                            <Divider className={classes.divider} />
                        </Grid>

                        {
                            allowPurchaseWHOIS() && 
                            <div>
                                <Grid item xs={12} >
                                    <Typography variant="subtitle1">{MyMess.domains.payment.whoisPrivacy}</Typography>
                                </Grid>
                                <Grid item xs={12} >
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={whoIsPrivacy}
                                                    onChange={handleWhoIsPrivacyChange}
                                                    name="whoIsPrivacy"
                                                    color="primary"
                                                />
                                            }
                                            label={MyMess.domains.purchasePrivacy}
                                        />
                                    </div>
                                    {MyMess.domains.payment.whoisDetail}
                                    <Divider className={classes.divider} />
                                </Grid>
                            </div>
                        }
                        
                        <Grid item xs={12} >
                            <Typography variant="subtitle1">{MyMess.domains.payment.domainOwnerInfo}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <List dense={true} >
                                <ListItem>
                                    <ListItemText
                                        primary={`${contactData.firstName} ${contactData.lastName}`}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={`${contactData.ownerEmail}`}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={`${formatPhoneNumber(contactData.phone)} `}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={`${contactData.companyName} `}
                                    />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <List dense={true}>
                                <ListItem>
                                    <ListItemText
                                        primary={contactData.address1}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={contactData.address2}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={`${contactData.city} (${contactData.postalCode})` }
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={contactData.country.label}
                                    />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12}>
                            {/* <Divider className={classes.divider} />
                            <div>
                                <Typography variant="subtitle2">WHOIS Privacy</Typography>
                                The domain includes WHOIS Privacy. This means your personal information won't be displayed in public registration record.
                            </div> */}
                            
                            <Divider className={classes.divider} />
                            <div>
                            <Typography variant="subtitle2">{MyMess.domains.payment.privacy}</Typography>
                                {MyMess.formatString(
                                    MyMess.domains.payment.agreementStatement,
                                    (<a target="_blank" href="https://www.icann.org/privacy/policy">{MyMess.domains.icannPrivacy}</a>),
                                    <a target="_blank" href={agreementState.list[0].url}>{MyMess.domains.acceptAgreementLinkText}</a>
                                    )}
                            </div>
                            <Divider className={classes.divider} />
                            {/* <div>
                                <Typography variant="subtitle2">Select Payment Methods</Typography>

                                <FormControlLabel
                                    control={<Checkbox checked={paymentMethod === 'alipay'} onChange={handlePaymentMethodChange} name="paymentMethod" value="alipay" />}
                                    label={'Alipay'}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={paymentMethod === 'wechatPay'} onChange={handlePaymentMethodChange} name="paymentMethod" value="wechatPay" />}
                                    label={'wechatPay'}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={paymentMethod === 'creditcard'} onChange={handlePaymentMethodChange} name="paymentMethod" value="creditcard" />}
                                    label={'creditcard'}
                                />
                            </div>
                            <Divider className={classes.divider} /> */}
                           
                        </Grid>
                        <Grid item xs={12} >
                            <Button onClick={handleBack} className={classes.button} >
                                {MyMess.general.back}
                            </Button>
                            <Button
                                onClick={handleConfirm}
                                type="button"
                                variant="contained"
                                color="primary"
                                className={classes.button}
                            >
                                {MyMess.general.pay}
                            </Button>
                        </Grid>
                    </Paper>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    return (
        <Container component="main" maxWidth="lg">
            {mainState.pending  && <LinearProgress />}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography component="h2" variant="h6" color="primary" gutterBottom>
                        {MyMess.domains.title}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">{MyMess.domains.buyNew.subtitle}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Stepper elevation={3} activeStep={activeStep}>
                        {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                        })}
                    </Stepper>
                </Grid>
                {renderSelectDomainStep()}
            </Grid>
            <Dialog disableBackdropClick disableEscapeKeyDown onClose={handleClose} aria-labelledby="simple-dialog-title" open={openQrCode}>
                <DialogTitle id="simple-dialog-title"> {MyMess.payment.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {MyMess.payment.instruction}
                    </DialogContentText>
                    <div>
                    <QrCode
                        qrCode={qrCodeString}
                        qrCodeType={paymentMethod.replace(".qrcode", "")}
                    />
                    </div>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {MyMess.general.cancel}
                </Button>
                </DialogActions>
            </Dialog>
        </Container>
        
    )
}

export default DomainsEditForm;